import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "variant"];
import { Badge as FoundationsBadge } from 'foundations-components/transitional/components/Badge';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Badge = _ref => {
  let {
      children,
      variant
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  return /*#__PURE__*/_jsx(FoundationsBadge, Object.assign({}, rest, spacingProps, {
    use: variant,
    children: children
  }));
};